<script setup lang="ts">
import { ref } from "vue";

import { useTypedIntl } from "@/locales/typed-intl";

import InputNumber from "primevue/inputnumber";

interface IProps {
  error?: string;
}

const model = defineModel<number | null | undefined>();
const props = defineProps<IProps>();

const intl = useTypedIntl();
const locale = ref(intl.locale);
</script>

<template>
  <InputNumber
    v-model="model"
    v-bind="$attrs"
    :invalid="!!props.error"
    :locale="locale"
  />
  <small
    v-if="props.error"
    class="text-red-500"
  >
    {{ props.error }}
  </small>
</template>
